import {
    Category,
    DayOfTheWeek,
    EvReport,
    OccupancyReport,
    ReportGroupBy,
    ReportState,
    ReportType
} from 'features/resource/types'
import { Epoch } from 'types/generics'
import {
    EventStatisticType,
    ParkingStatInterval,
    ParkingEventType
} from 'features/resource/types/parkingStat'


export {
    isOverflow,
    isHistogram,
    isPrediction,
    isEv
} from 'features/resource/reportUtils'


// Configs
export interface ClientConfig {
    groupConfigs: GroupConfig[]
    hideResourceIds?: string[]
    jurisdictionId: string
    zoneName: string
}


export interface GroupConfig {
    // Optional: (width, height, maxWidth, maxHeight, etc)
    id: string
    index: number
    reportConfigs: (ReportConfig | FeedConfig)[]
    style?: object
}


export interface ReportConfig {
    dashboardReportType: DashboardReportType
    daysOfTheWeek: DayOfTheWeek[]
    groupBy: ReportGroupBy
    id: string // UUID for this report
    index: number //  Order to display this report within the group
    provider?: OccupancyProvider
    reportType: ReportType
    selectedCategories: Category[]
    selectedResourceIds: string[]
    weekOffset: number
    data?: EvReport | OccupancyReport
}

export interface OccupancyProvider {
    color: string
    name: string
}



export interface FeedConfig extends ReportConfig {
    intervals: ParkingStatInterval[]
    keys: ParkingEventType[]
    statisticTypes: EventStatisticType[]
}


// Report Types
export type DashboardReportType = ReportType | DashboardReportTypes_


enum DashboardReportTypes_ {
    liveOccupancy = 'liveOccupancy',
    statsFeed = 'statsFeed',
    statsChart = 'statsChart'
}


export const DashboardReportTypes = {...DashboardReportTypes_, ...ReportType}


export interface LiveOccupancyState {
    groupId: string
    id: string
    lastUpdated: Epoch
    occupancyPercentage: number
    selectedResourceIds: string[]
    spacesAvailable: number
    spacesOccupied: number
}


export interface DashboardReportState extends ReportState {
    groupId: string
    id: string
}


export const isLiveOccupancy = (dashboardReportType: DashboardReportType) =>
    DashboardReportTypes.liveOccupancy === dashboardReportType

export const isStatsFeed = (dashboardReportType: DashboardReportType) =>
    DashboardReportTypes.statsFeed === dashboardReportType

export const isStatsChart = (dashboardReportType: DashboardReportType) =>
    DashboardReportTypes.statsChart === dashboardReportType
